<template>
  <v-dialog v-model="open" max-width="460" @click:outside="$emit('cancel')">
    <v-card>
      <v-card-title>
        {{ $t('media.discard_changes_confirmation_title') }}
      </v-card-title>

      <v-card-text>
        {{ $t('media.discard_changes_confirmation_message') }}
      </v-card-text>

      <v-card-actions class="justify-end">
        <Button
          plain
          color="red"
          :text="$t('media.discard_changes_discard_button')"
          @click="$emit('discard')"
        />

        <Button
          plain
          color="grey"
          :text="saveButtonText"
          @click="$emit('save')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'DiscardChangesConfirmation',
  components: {
    Button,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },

    saveButtonText: {
      type: String,
      required: true,
    },
  },
}
</script>
